import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material'; // Buttonとアイコンを追加
import { SubmitButton } from '../../style/button';

const PdfViewer = ({ icon: Icon, title, fileUrl, deviceType }) => {  
  return (
    <Box sx={{ flex: 1, minWidth: 300 }}>
      {title && Icon && (
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Icon sx={{ mr: 1 }} />
          <Typography variant="subtitle1">{title}</Typography>
        </Box>
      )}
      {deviceType === 'mobile' ? (
        // モバイル向けレンダリング
        <Box sx={{ p: 2, textAlign: 'center' }}>
          <SubmitButton
            variant="contained"
            href={fileUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            PDFを開く
          </SubmitButton>
        </Box>
      ) : (
        // デスクトップ向けレンダリング
        <Box sx={{ width: '100%', height: '65vh', border: '1px solid #ccc' }}>
          <object data={fileUrl} type="application/pdf" width="100%" height="100%">
            <p>
              PDFを表示できません。直接
              <a href={fileUrl} target="_blank" rel="noopener noreferrer">
                こちら
              </a>
              をクリックしてください。
            </p>
          </object>
        </Box>
      )}
    </Box>
  );
};

export default PdfViewer;